import { render, staticRenderFns } from "./CreateResume.vue?vue&type=template&id=10612773&scoped=true"
import script from "./CreateResume.vue?vue&type=script&lang=js"
export * from "./CreateResume.vue?vue&type=script&lang=js"
import style0 from "./CreateResume.vue?vue&type=style&index=0&id=10612773&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10612773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10612773')) {
      api.createRecord('10612773', component.options)
    } else {
      api.reload('10612773', component.options)
    }
    module.hot.accept("./CreateResume.vue?vue&type=template&id=10612773&scoped=true", function () {
      api.rerender('10612773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/CreateResume.vue"
export default component.exports